import { apiGet, apiPost } from 'chipta-libs/api/utils.js';

class TicketshopAPI {

  constructor() {
    this.eventData = null;
  }

  getEventData({resetReservations = true} = {}) {

    return new Promise((success, reject) => {

      apiGet(
        'ticketshop/' + _eventId + '/'
        + '?reset-reservations=' + (resetReservations ? 1 : 0)
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  reserveProduct(id, quantity, options={}) {

    const data = {
      product: id,
      quantity: quantity
    };

    if ('donationAmount' in options) {
      data['donation_amount'] = options.donationAmount;
    }

    const getQueryString = () => {
      if (options['uniqueCode']) {
        return '?unique-code=' + options['uniqueCode'];
      } else {
        return '';
      }
    };

    return new Promise((success, reject) => {

      apiPost(
        'ticketshop/' + _eventId +
        '/reserve-products/' + getQueryString(),
        data
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  login(email, password, rememberMe=false) {

    return new Promise((success, reject) => {

      const data = {
        // If there's an Event ID, send it, so that the user keeps it's
        // current reservations on that event after logging in.
        'event_id': window._eventId || null,
        'email': email,
        'password': password,
        'remember_me': rememberMe
      };

      apiPost(
        'ticketshop/login/',
        data
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  facebookLogin(userId, accessToken) {

    return new Promise((success, reject) => {

      apiPost(
        'ticketshop/' + _eventId + '/facebook-login/',
        {
          'user_id': userId,
          'access_token': accessToken
        }
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  logout() {

    return new Promise((success, reject) => {

      // If there's an Event ID, send it, so that the guest of the logged in
      // user will be converted to a pre-guest, so that the user keeps it's
      // reservations after logging out.
      const data = { 'event_id': window._eventId || '' };

      apiPost('ticketshop/logout/', data).then(response => {
        this.userData = null;
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  createPayment(method, methodOption, buyOnlyUserData={}, questionAnswers, options={}) {

    return new Promise((success, reject) => {

      const data = buyOnlyUserData;
      data['question_answers'] = questionAnswers;
      data['method'] = method;
      data['method_option'] = methodOption;
      data['ticketshop_version'] = 'v4.1.0';

      if (options['uniqueCode']) {
        data['unique_code'] = options['uniqueCode'];
      }

      if (options['iframe']) {
        data['iframe'] = true;
      }

      apiPost(
        'ticketshop/' + _eventId + '/create-payment/',
        data
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

  checkUniqueCode(code) {

    return new Promise((success, reject) => {

      apiPost(
        'ticketshop/' + _eventId + '/check-unique-code/',
        {'unique_code': code}
      ).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });

    });

  }

}

export default new TicketshopAPI();
